module.exports = __webpack_public_path__ + "img/leaf-word-2.6048055a.png";